import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHTML' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }
  transform(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({
  name: "currencyFormat",
  standalone: true,
})
// export class CurrencyFormatPipe implements PipeTransform {
//   transform(value: number, currencyDecimals: number): string {
//     if (value === null || value === undefined) {
//       return "";
//     }

//     // If currency_decimals is missing, default to 2
//     let decimals = currencyDecimals ?? 2;

//     // Format the number with the specified decimal places
//     return value.toLocaleString("en-US", {
//       minimumFractionDigits: decimals,
//       maximumFractionDigits: decimals,
//     });
//   }
// }
export class CurrencyFormatPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    currencyDecimals: number = 2,
  ): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    // Remove commas if the API returns a formatted string, e.g. "125,000"
    const numericValue =
      typeof value === "string" ? Number(value.replace(/,/g, "")) : value;

    if (!Number.isFinite(numericValue)) {
      return "";
    }

    const decimals = currencyDecimals ?? 2;

    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
}